import {
    aacProdEuConfigs,
    aacProdFeConfigs,
    ihubConfigs,
    blinkConfigs,
} from "../config/auth.config";

export const testSiteUrls = [...ihubConfigs.keys(), ...blinkConfigs.keys()];
export const isTestSiteOrDev = (): boolean => {
    const host: string = window.location.hostname;
    return testSiteUrls.includes(host) || isDev();
};

export const isDev = (): boolean => {
    const host: string = window.location.hostname;
    const port: string = window.location.port;
    return port === "3000" || host.includes("localhost");
};

export enum Region {
    NA = "na",
    EU = "eu",
    FE = "fe",
}

export const getRegion = (): Region => {
    const hostname = window.location.hostname;

    if ([...aacProdFeConfigs.keys()].includes(hostname)) {
        return Region.FE;
    }

    if ([...aacProdEuConfigs.keys()].includes(hostname)) {
        return Region.EU;
    }

    return Region.NA;
};
